<template>
  <div class="mod-config">
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection"
                       header-align="center"
                       align="center"
                       width="50">
      </el-table-column>
      <el-table-column prop="id"
                       header-align="center"
                       align="center"
                       label="圈id">
      </el-table-column>
      <el-table-column prop="name"
                       header-align="center"
                       align="center"
                       label="名字">
      </el-table-column>
      <el-table-column prop="headurl"
                       header-align="center"
                       align="center"
                       label="头像">
        <template slot-scope="scope2">
          <img :src="scope2.row.headurl"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="titles"
                       header-align="center"
                       align="center"
                       label="标题">
      </el-table-column>
      <el-table-column prop="file1"
                       header-align="center"
                       align="center"
                       label="图片1">
        <template slot-scope="scope2">
          <img :src="scope2.row.file1"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="file2"
                       header-align="center"
                       align="center"
                       label="图片2">
        <template slot-scope="scope2">
          <img :src="scope2.row.file2"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="file3"
                       header-align="center"
                       align="center"
                       label="图片3">
        <template slot-scope="scope2">
          <img :src="scope2.row.file3"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="file4"
                       header-align="center"
                       align="center"
                       label="图片4">
        <template slot-scope="scope2">
          <img :src="scope2.row.file4"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="file5"
                       header-align="center"
                       align="center"
                       label="图片5">
        <template slot-scope="scope2">
          <img :src="scope2.row.file5"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="file6"
                       header-align="center"
                       align="center"
                       label="图片6">
        <template slot-scope="scope2">
          <img :src="scope2.row.file6"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="createtime"
                       header-align="center"
                       align="center"
                       label="创建时间">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       width="150"
                       label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle"
                   :current-page="pageIndex"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="pageSize"
                   :total="totalPage"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible"
                   ref="addOrUpdate"
                   @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from '@/components/jgquanzi-add-or-update'
export default {
  data () {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgquanzi/getalllist',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'key': this.dataForm.key
        }
      }).then((data) => {
        data = data.data
        if (data.length != 0) {
          this.dataList = data
          
        } else {
          this.dataList = []
          
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      console.log(id)
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.global.apiUrl + '/jxjg/jgquanzi/delete',
          method: 'post',
          params: {
            'id': id
          }
        }).then((data) => {
          data = data.body
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/jgquanzi.vue